<script setup lang="ts">
import { AddOn } from '../types'

const props = defineProps<{
  addOn: AddOn
  isSelected?: boolean
  disabled?: boolean
  onClick?: (value: AddOn) => void
}>()

const handleClick = () => {
  if (props.disabled) return
  props.onClick?.(props.addOn)
}
</script>

<template>
  <div
    class="rounded-lg border border-gray-300 bg-white px-4 py-3 shadow-sm transition"
    :class="disabled ? 'cursor-not-allowed opacity-60 shadow-none' : 'hover:shadow-md'"
    :aria-disabled="disabled"
  >
    <label class="flex flex-col gap-4" :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'">
      <div class="flex items-start justify-between gap-4">
        <div class="flex flex-1 items-start gap-3">
          <input
            type="checkbox"
            class="mt-1 h-4 w-4 rounded border-gray-300 text-[#3b88af] focus:ring-[#3b88af]"
            :checked="isSelected"
            :disabled="disabled"
            @change="handleClick"
          />
          <div>
            <div class="text-base font-medium text-gray-900">{{ addOn.title }}</div>
            <p class="mt-1 text-sm text-gray-500">{{ addOn.description }}</p>
          </div>
        </div>
        <div class="text-right">
          <div class="text-sm font-semibold text-gray-900">{{ addOn.price }}</div>
        </div>
      </div>
    </label>
  </div>
</template>
